import Vue from 'vue'
import Vue2Filters from 'vue2-filters'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueNoty from 'vuejs-noty'
import VueMq from 'vue-mq'
import VueFloater from 'vue-floater'
import VCalendar from 'v-calendar'
// import VueGtag from 'vue-gtag'
// import VueAnalytics from 'vue-analytics'
import VueAnalytics from 'vue-ua'
import 'core-js/stable'
import 'core-js/es/object'
import 'regenerator-runtime/runtime'
import 'intersection-observer'
import { registerFilters } from '@utils/filters'

// Sentry instrumentation
import * as Sentry from '@sentry/vue'
// import * as Integrations from '@sentry/integrations'
import { Integrations } from '@sentry/tracing'

import App from './app'
import router from '@router'
import store from '@state/store'
import '@components/_globals'

import 'animate.css'
import {
  FontAwesomeIcon,
  FontAwesomeLayers,
} from '@fortawesome/vue-fontawesome'
import '@utils/font-awesome-icons'
import '@utils/validation-initialization'
import '@utils/screen-helpers'

var domain = window.location.hostname
// var debug = false
var baseDomain = 'https://api.shoponcampus.com'
let baseUrl = 'https://shoponcampus.com'

// if (domain === 'localhost') {
//   debug = true
// }

const ua = window.navigator.userAgent
const agents = [/sitecheck/i, /siteimprove/i, /bing/i]
const uaMatch = agents.some((re) => re.test(ua))

const debug = domain === 'localhost'

if (!debug && !uaMatch) {
  Sentry.init({
    Vue: Vue,
    dsn:
      'https://fee7bfa8a8314b9cad5616740470385b@o167250.ingest.sentry.io/5524195',
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 0.2,
  })
}

// if (!debug) {
//   Sentry.init({
//     Vue: Vue,
//     dsn:
//       'https://fee7bfa8a8314b9cad5616740470385b@o167250.ingest.sentry.io/5524195',
//     integrations: [
//       new Integrations.Vue({ Vue, attachProps: true }),
//       new Integrations.ReportingObserver(),
//       new Integrations.Dedupe(),
//     ],
//   })
// }

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyC7P0wKiQ7n9ktODqC-HuS5FKuhL2Xxl6M',
  },
})

// Vue.use(
//   VueGtag,
//   {
//     config: { id: 'UA-181276722-1' },
//   },
//   router
// )

let useGA = false
if (process.env.NODE_ENV === 'production') {
  useGA = true
}

// console.log('useGA', useGA)
// console.log('env', process.env.NODE_ENV)

// Vue.use(VueAnalytics, {
//   id: 'UA-181276722-1',
//   router,
//   checkDuplicatedScript: true,
//   debug: {
//     sendHitTask: true,
//   },
// })

if (useGA === true) {
  Vue.use(VueAnalytics, {
    appName: 'Shop On Campus',
    appVersion: '2.0',
    trackingId: 'UA-181276722-1',
    debug: false,
    vueRouter: router,
    trackPage: true,
  })
}

Vue.use(Vue2Filters)
Vue.use(VueAwesomeSwiper /* { default global options } */)
Vue.use(VueNoty)
Vue.use(VueFloater)
Vue.component('font-awesome-icon', FontAwesomeIcon) // Use the icon component anywhere in the app
Vue.component('FontAwesomeIcon', FontAwesomeIcon) // Use the icon component anywhere in the app
Vue.component('font-awesome-layers', FontAwesomeLayers)

// /* Sample function that returns boolean in case the browser is Internet Explorer */
// function isIE() {
//   let ua = navigator.userAgent
//   /* MSIE used to detect old browsers and Trident used to newer ones */
//   var isIE = ua.indexOf('MSIE ') > -1 || ua.indexOf('Trident/') > -1

//   return isIE
// }

// let VCalendar
// /* Create an alert to show if the browser is IE or not */
// if (isIE()) {
//   VCalendar = require('@/assets/vendor/v-calendar.min.js')
// } else {
//   VCalendar = require('v-calendar')
// }

Vue.use(VCalendar)

// Register custom filters
registerFilters(Vue)

// If running inside Cypress...
if (process.env.VUE_APP_TEST === 'e2e') {
  // Ensure tests fail when Vue emits an error.
  Vue.config.errorHandler = window.Cypress.cy.onUncaughtException
}

if (debug === true) {
  Vue.config.productionTip = true
  Vue.config.devtools = true
  Vue.config.performance = true
} else {
  // Don't warn about using the dev version of Vue in development.
  Vue.config.productionTip = false
  Vue.config.devtools = false
  Vue.config.performance = false
}

// Set development and staging API URLs
if (domain === 'localhost') {
  baseUrl = 'http://localhost:8080'
  baseDomain = 'http://localhost:3000'
}
if (domain === 'qa.shoponcampus.com') {
  baseUrl = 'https://qa.shoponcampus.com'
  baseDomain = 'https://railsapi.dineoncampus.com'
}

Vue.prototype.$baseDomain = baseDomain
Vue.prototype.$baseUrl = baseUrl

Vue.use(VueMq, {
  breakpoints: {
    xs: 575,
    sm: 767,
    md: 991,
    lg: 1199,
    xl: Infinity,
  },
})

const app = new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')

// If running e2e tests...
if (process.env.VUE_APP_TEST === 'e2e') {
  // Attach the app to the window, which can be useful
  // for manually setting state in Cypress commands
  // such as `cy.logIn()`.
  window.__app__ = app
}
